import { render, staticRenderFns } from "./ProfileBanner.vue?vue&type=template&id=29f51edf&scoped=true"
import script from "./ProfileBanner.vue?vue&type=script&lang=ts"
export * from "./ProfileBanner.vue?vue&type=script&lang=ts"
import style0 from "./ProfileBanner.vue?vue&type=style&index=0&id=29f51edf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f51edf",
  null
  
)

export default component.exports